"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UTM_PARAM_NAMES = exports.SESSION_START_TIME_KEY_NAME = exports.SESSION_ID_KEY_NAME = exports.ROOT_DOMAIN_COOKIES = exports.RETRYABLE_STATUS_CODES = exports.RECORD_BATCH_SCHEMA_ID_ENV_MAP = exports.RECORD_BATCH_SCHEMA = exports.RECORD_BATCH_ENDPOINT_ROUTE = exports.LIGHTRICKS_ID_COOKIE_NAME = exports.IS_LTX_TEAM_COOKIE_NAME = exports.HALF_AN_HOUR = exports.DELTA_BATCH_CUSTOM_EVENT_NAME = exports.DEFAULT_BATCH_COUNTDOWN_TIME_IN_MILLISECONDS = exports.BODY_SIZE_LIMIT_IN_BYTES = exports.ANONYMOUS_ID_COOKIE_NAME = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var RECORD_BATCH_ENDPOINT_ROUTE = "/record_batch";
exports.RECORD_BATCH_ENDPOINT_ROUTE = RECORD_BATCH_ENDPOINT_ROUTE;
var INTERNAL_SERVER_ERROR_CODES = _toConsumableArray(Array(100).keys()).map(function (i) {
  return i + 500;
});
var REQUEST_TIMEOUT_ERROR_CODE = 408;
var TOO_MANY_REQUESTS_ERROR_CODE = 429;
var RETRYABLE_STATUS_CODES = [].concat(_toConsumableArray(INTERNAL_SERVER_ERROR_CODES), [REQUEST_TIMEOUT_ERROR_CODE, TOO_MANY_REQUESTS_ERROR_CODE]);
exports.RETRYABLE_STATUS_CODES = RETRYABLE_STATUS_CODES;
var DEFAULT_BATCH_COUNTDOWN_TIME_IN_SECONDS = 20;
var DEFAULT_BATCH_COUNTDOWN_TIME_IN_MILLISECONDS = DEFAULT_BATCH_COUNTDOWN_TIME_IN_SECONDS * 1000;
exports.DEFAULT_BATCH_COUNTDOWN_TIME_IN_MILLISECONDS = DEFAULT_BATCH_COUNTDOWN_TIME_IN_MILLISECONDS;
var BYTES_IN_MiB = 1024;
var BODY_SIZE_LIMIT_IN_MiB = 5;
var BODY_SIZE_LIMIT_IN_BYTES = BODY_SIZE_LIMIT_IN_MiB * BYTES_IN_MiB;
exports.BODY_SIZE_LIMIT_IN_BYTES = BODY_SIZE_LIMIT_IN_BYTES;
var ANONYMOUS_ID_COOKIE_NAME = "anonymous_id";
exports.ANONYMOUS_ID_COOKIE_NAME = ANONYMOUS_ID_COOKIE_NAME;
var LIGHTRICKS_ID_COOKIE_NAME = "lt_id";
exports.LIGHTRICKS_ID_COOKIE_NAME = LIGHTRICKS_ID_COOKIE_NAME;
var SESSION_ID_KEY_NAME = "session_id";
exports.SESSION_ID_KEY_NAME = SESSION_ID_KEY_NAME;
var SESSION_START_TIME_KEY_NAME = "session_start_time";
exports.SESSION_START_TIME_KEY_NAME = SESSION_START_TIME_KEY_NAME;
var DELTA_BATCH_CUSTOM_EVENT_NAME = "onDeltaBatchSent";
exports.DELTA_BATCH_CUSTOM_EVENT_NAME = DELTA_BATCH_CUSTOM_EVENT_NAME;
var HALF_AN_HOUR = 1000 * 60 * 30;
exports.HALF_AN_HOUR = HALF_AN_HOUR;
var UTM_PARAM_NAMES = ["utm_source", "utm_medium", "utm_campaign", "utm_placement", "utm_campaign_name", "utm_adset_name", "utm_ad_name", "utm_ad_id", "utm_adset_id", "utm_search", "gclid", "fbid", "ttclid"];
exports.UTM_PARAM_NAMES = UTM_PARAM_NAMES;
var RECORD_BATCH_SCHEMA_ID_ENV_MAP = {
  integration: 100002,
  production: 103055
};
exports.RECORD_BATCH_SCHEMA_ID_ENV_MAP = RECORD_BATCH_SCHEMA_ID_ENV_MAP;
var RECORD_BATCH_SCHEMA = {
  name: "RecordBatch",
  namespace: "com.lightricks.data.avro",
  type: "record",
  fields: [{
    name: "records",
    type: {
      type: "array",
      items: {
        name: "SingleRecord",
        type: "record",
        fields: [{
          name: "schema_id",
          type: "long",
          doc: "The `schema_id` identifying the schema of the bytes in the `record_payload` field."
        }, {
          name: "event_id",
          type: "string",
          doc: "The event_id of the event record in the `record_payload` field."
        }, {
          name: "event_timestamp",
          type: "long",
          doc: "The UTC Epoch timestamp in milliseconds of when the event occurred, for the event record in the `record_payload` field."
        }, {
          name: "platform",
          type: "string",
          doc: "The name of the platform (e.g ios, android, backend, web) for the event record in the `record_payload` field."
        }, {
          name: "source_identifier",
          type: "string",
          doc: "The name of the app/source (e.g. facetune2, ftvideo, videoleap) for the event record in the `record_payload` field."
        }, {
          name: "event_payload",
          type: "bytes",
          doc: "The actual bytes of the avro-encoded event record"
        }]
      }
    }
  }]
};
exports.RECORD_BATCH_SCHEMA = RECORD_BATCH_SCHEMA;
var IS_LTX_TEAM_COOKIE_NAME = "is_lt_team";

// These cookies are set on the root domain (WP site) and used to
// associate AWA activity with a user's activity on the WP site.
exports.IS_LTX_TEAM_COOKIE_NAME = IS_LTX_TEAM_COOKIE_NAME;
var ROOT_DOMAIN_COOKIES = {
  anonymousId: "ltx-anonymous-id",
  visitId: "ltx-visit-id"
};
exports.ROOT_DOMAIN_COOKIES = ROOT_DOMAIN_COOKIES;